// extracted by mini-css-extract-plugin
export default {"boardItem":"CurrentFtse100_boardItem__sP5x7","ftse100":"CurrentFtse100_ftse100__vIxur","relevantIcon":"CurrentFtse100_relevantIcon__bEzT6"};